import React from 'react';

export default function UserIcon(props) {
  return (
    <svg role='presentation' width='32' height='32' viewBox='0 0 32 32' {...props}>
      <path
        d='M16 16c4.933 0 9 3.448 9 7.8 0 .663-.543 1.2-1.213 1.2H8.213C7.543 25 7 24.463 7 23.8c0-4.352 4.067-7.8 9-7.8zm0-10a5 5 0 1 1 0 10 5 5 0 0 1 0-10z'
        fill='currentColor'
        fillRule='nonzero'
      />
    </svg>
  );
}
